import moment from "moment"
import React, { useEffect, useState } from "react"
import ScaleLoader from "react-spinners/ScaleLoader"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { GLOBAL_CONSTANTS } from "../../constants/constants"
import { RootState } from "../../store"
import { loadSuites } from "../../store/suite.store"
import Header from "../Layout/Header"
import SuitesTable from "./SuitesTable"

const Suites = () => {
    const dispatch = useAppDispatch()
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { suites, loading } = useAppSelector((state: RootState) => state.suites)
    const [page, setpage] = useState(GLOBAL_CONSTANTS.PAGE)
    const [pageSize, setPageSize] = useState(GLOBAL_CONSTANTS.PAGE_SIZE)
    const [search, setSearch] = useState("")
    const [status, setStatus] = useState("")
    const tableDataChange = (page: number, page_size: number) => {
        setpage(page)
        setPageSize(page_size)
    }
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)

    const serachDetailChange = (searchParam: string, statusParam: string) => {
        searchParam && setSearch(searchParam)
        statusParam && setStatus(statusParam)
    }
    const defaultWarehouse = userInfo?.ParcelHubUserWarehouse?.find(
        (uw: Record<string, any>) => uw?.is_default
    )?.warehouse_id

    useEffect(() => {
        if (suites?.total === 0) {
            dispatch(loadSuites({ page, pageSize, search, status, warehouse: selectedWarehouse?.toString() }))
        }
    }, [selectedWarehouse])

    useEffect(() => {
        dispatch(loadSuites({ page, pageSize, search, status, warehouse: selectedWarehouse?.toString() }))
    }, [search, status, selectedWarehouse])

    useEffect(() => {
        dispatch(loadSuites({ page, pageSize, search, status, warehouse: selectedWarehouse?.toString() }))
    }, [page, pageSize, selectedWarehouse])

    //Date Picker Logic
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")

    useEffect(() => {
        const dateObj2 = {
            start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : "2020-04-15",
            end_date: endDate
                ? moment(endDate).format("YYYY-MM-DD")
                : moment().add(1, "days").format("YYYY-MM-DD")
        }

        //TODO: Call dispatch(load***()) for all
    }, [endDate])
    return (
        <>
            <div className="suites-container">
                <Header
                    title="Suites"
                    records={suites.total}
                    data={suites?.suites}
                    name="Suites"
                    buttonId=".suitesExportButton">
                    {/* <div className="mx-2">
                            <DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate} startDate={startDate} endDate={endDate}/>
                        </div> */}
                </Header>
                {loading || !userInfo?.accessToken ? (
                    <div className="loader row justify-content-center">
                        <ScaleLoader color="#15397F" width={4} height={40} />
                    </div>
                ) : (
                    <div className="row d-flex px-2">
                        <SuitesTable
                            search={search}
                            status={status}
                            suites={suites}
                            tableDataChange={tableDataChange}
                            serachDetailChange={serachDetailChange}
                        />
                    </div>
                )}
            </div>
        </>
    )
}

export default Suites
